import { render } from "./MyButton.vue?vue&type=template&id=fb423464&scoped=true"
import script from "./MyButton.vue?vue&type=script&lang=js"
export * from "./MyButton.vue?vue&type=script&lang=js"

import "./MyButton.vue?vue&type=style&index=0&id=fb423464&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\wwwda\\OneDrive\\Desktop\\проекты-и-учебные-файлы-front\\pizzares\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb423464"]])

export default __exports__